/* cl-interactive (feelingirl): vida das secoes copiadas do Prestige 10 dele. O scope remove todo
   <script>; os custom elements dele viraram cl-* e nao tem construtor. Nota do operador: nenhum botao
   morto, FAQ expande, grids com swipe (toque no mobile), video toca.
   1. cl-slideshow-carousel: slides .is-selected + bolinhas (cl-carousel-navigation), autoplay, toque.
   2. cl-scroll-carousel (trilho overflow-x): setas cl-carousel-prev/next-button.
   3. slick ASSADO no extract (logo-list mobile): o markup fica igual (clones, transform), o motor
      abaixo so desloca o .slick-track por um slide, com loop pelos clones, setas e toque.
   4. cl-marquee-text: faixa rolando em rAF (o Prestige anima por JS; nao ha @keyframes no CSS dele).
   5. acordeoes: <details> nativo (accordion-disclosure dele) e button[aria-controls].
   6. colecao: Sort/Filter (popover e gaveta).
   7. video mudo sem controles toca em loop na tela. */
(function () {
  if (window.__clInteractive) return; window.__clInteractive = true;
  var SEC = '[class*="cl-sec-"]';

  function swipe(el, onLeft, onRight) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) onLeft(); else onRight(); }
      x0 = null;
    }, { passive: true });
    var mx = null;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') mx = e.clientX; });
    el.addEventListener('pointerup', function (e) {
      if (mx === null || e.pointerType !== 'mouse') return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) > 40) { if (dx < 0) onLeft(); else onRight(); }
    });
  }

  /* 1 */
  function slideshows() {
    document.querySelectorAll(SEC + ' cl-slideshow-carousel').forEach(function (root) {
      if (root.__cl) return; root.__cl = 1;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.clx-slideshow__slide, .slideshow__slide'));
      if (slides.length < 2) return;
      var sec = root.closest(SEC) || root.parentElement;
      var nav = sec.querySelector('cl-carousel-navigation');
      var dots = nav ? Array.prototype.slice.call(nav.querySelectorAll('button')) : [];
      var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-selected'); })), t;
      /* o extract assou opacity:0 (e translate) no <img> e no texto dos slides que nao estavam na tela:
         sem desfazer, o slide 2 entrava selecionado e invisivel. Transicao = a do Prestige dele (medida):
         texto do slide que sai some (.2s, +10px); a foto nova entra com fade + zoom 1.2->1 (.7s) e o
         texto dela sobe 30px->0 com fade (.35s, depois de .4s). */
      function parts(s) { return { img: s.querySelectorAll('picture img, video'), txt: s.querySelectorAll('.prose') }; }
      function reveal(s) {
        s.querySelectorAll('[style*="opacity"]').forEach(function (e) { e.style.opacity = ''; e.style.transform = ''; });
      }
      slides.forEach(function (s, k) { if (k !== i) reveal(s); });
      function anim(el, kf, o) { try { return el.animate(kf, o); } catch (e) { return null; } }
      function go(n) {
        var old = slides[i];
        n = (n + slides.length) % slides.length;
        if (n === i) return;
        var p0 = parts(old);
        p0.txt.forEach(function (e) { anim(e, [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(10px)' }], { duration: 200, easing: 'ease-in', fill: 'forwards' }); });
        old.classList.remove('is-selected');
        i = n;
        var cur = slides[i]; reveal(cur);
        cur.classList.add('is-selected');
        var p1 = parts(cur);
        p1.img.forEach(function (e) { anim(e, [{ opacity: 0, transform: 'scale(1.2)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 700, easing: 'cubic-bezier(.22,.61,.36,1)' }); });
        p1.txt.forEach(function (e) { var a = anim(e, [{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, delay: 400, easing: 'ease-out', fill: 'backwards' }); });
        setTimeout(function () { p0.txt.forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (a) { a.cancel(); }); }); }, 260);
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        cur.querySelectorAll('video').forEach(function (v) { v.play && v.play().catch(function () {}); });
      }
      var every = (parseFloat(root.getAttribute('autoplay')) || 5) * 1000;
      function auto() { clearInterval(t); t = setInterval(function () { go(i + 1); }, every); }
      dots.forEach(function (d, k) { d.addEventListener('click', function (e) { e.preventDefault(); go(k); auto(); }); });
      sec.querySelectorAll('cl-carousel-prev-button, cl-carousel-next-button').forEach(function (b) {
        if (b.closest('cl-scroll-carousel, .scroll-area')) return;
        b.addEventListener('click', function (e) { e.preventDefault(); go(i + (b.tagName.toLowerCase().indexOf('next') > -1 ? 1 : -1)); auto(); });
      });
      swipe(root, function () { go(i + 1); auto(); }, function () { go(i - 1); auto(); });
      auto();
    });
  }

  /* 2 */
  function scrollCarousels() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest(SEC + ' cl-carousel-prev-button, ' + SEC + ' cl-carousel-next-button');
      if (!b) return;
      var sec = b.closest('.shopify-section, ' + SEC);
      var track = null, ctl = b.getAttribute('aria-controls');
      if (ctl) track = document.getElementById(ctl);
      if (!track) track = sec && sec.querySelector('cl-scroll-carousel, .scroll-area, cl-product-list.is-scrollable, .product-list--carousel');
      if (!track || track.scrollWidth <= track.clientWidth + 2) return;
      e.preventDefault();
      var kid = track.firstElementChild, gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = kid ? kid.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      var dir = b.tagName.toLowerCase().indexOf('next') > -1 ? 1 : -1;
      if (getComputedStyle(track).direction === 'rtl') dir = -dir;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });
  }

  /* 3 */
  function slicks() {
    document.querySelectorAll(SEC + ' .slick-slider').forEach(function (sl) {
      if (sl.__cl) return;
      var track = sl.querySelector('.slick-track');
      if (!track || !sl.offsetParent) return;
      var all = Array.prototype.slice.call(track.children);
      var real = all.filter(function (s) { return !s.classList.contains('slick-cloned'); });
      if (real.length < 2) return;
      sl.__cl = 1;
      var w = all[0].getBoundingClientRect().width;
      if (!w) { sl.__cl = 0; return; }
      var firstReal = all.indexOf(real[0]);
      var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
      var base = m ? parseFloat(m[1]) : 0;            /* deslocamento do slide atual no extract */
      var cur = all.findIndex(function (s) { return s.classList.contains('slick-current'); });
      if (cur < 0) cur = firstReal;
      var idx = cur - firstReal;                        /* indice real */
      var list = sl.querySelector('.slick-list') || sl;
      var centered = !!track.querySelector('.slick-center');
      /* o transform assado no extract foi medido em OUTRA largura: recalcula como o slick (centerMode) */
      /* centro da tela, descontando onde o .slick-list comeca e o padding que o centerMode poe nele */
      var lr = list.getBoundingClientRect(), pl = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      var off0 = centered ? (document.documentElement.clientWidth - w) / 2 - lr.left - pl : base + cur * w;
      if (centered) { idx = 0; }
      function place(anim) {
        track.style.transition = anim ? 'transform .45s ease' : 'none';
        track.style.transform = 'translate3d(' + (off0 - (firstReal + idx) * w) + 'px, 0px, 0px)';
      }
      function mark() {
        all.forEach(function (s) { s.classList.remove('slick-current', 'slick-active', 'slick-center'); });
        var k = firstReal + ((idx % real.length) + real.length) % real.length;
        if (all[k]) all[k].classList.add('slick-current', 'slick-active', 'slick-center');
      }
      function go(d) {
        idx += d; place(true); mark();
        setTimeout(function () {
          if (idx < 0 || idx >= real.length) { idx = (idx % real.length + real.length) % real.length; place(false); mark(); }
        }, 470);
      }
      if (centered) { place(false); mark(); }
      var p = sl.querySelector('.slick-prev'), n = sl.querySelector('.slick-next');
      if (p) p.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      if (n) n.addEventListener('click', function (e) { e.preventDefault(); go(1); });
      swipe(sl, function () { go(1); }, function () { go(-1); });
      (sl.querySelectorAll('.slick-dots button') || []).forEach(function (b, k) {
        b.addEventListener('click', function (e) { e.preventDefault(); go(k - (((idx % real.length) + real.length) % real.length)); });
      });
    });
  }

  /* 4 */
  /* marquee-text do Prestige 10: o scroller e um <slot part="scroller"> no shadow DOM, da largura da 1a
     faixa; os clones (position:absolute; inset-inline-start: 100%/200%...) ficam relativos a ELE. Sem
     esse wrapper o absoluto caia NA LINHA DE BAIXO (posicao estatica depois do bloco) e a faixa
     quebrava em duas linhas. Recria o scroller como um div e anda 60px/s (speed 0.2, medido ao vivo). */
  function marquees() {
    document.querySelectorAll(SEC + ' cl-marquee-text').forEach(function (mq) {
      if (mq.__cl) return;
      var first = mq.querySelector('.scrolling-content__item');
      if (!first) return;
      var sc = mq.querySelector(':scope > .cl-mq-scroller');
      if (!sc) {
        sc = document.createElement('div'); sc.className = 'cl-mq-scroller';
        sc.style.cssText = 'position:relative;width:max-content;max-width:none;will-change:transform';
        while (mq.firstChild) sc.appendChild(mq.firstChild);
        mq.appendChild(sc);
      }
      mq.querySelectorAll('.scrolling-content__item').forEach(function (it) { it.style.transform = ''; it.style.marginLeft = ''; });
      var iw = sc.getBoundingClientRect().width;
      if (!iw) return;
      mq.__cl = 1;
      var tracks = sc.querySelectorAll(':scope > .scrolling-content__item');
      var need = Math.ceil(mq.clientWidth / iw) + 2;
      for (var k = tracks.length; k < need; k++) {
        var c = first.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.classList.add('cl-mq-clone');
        c.style.position = 'absolute'; c.style.insetInlineStart = (100 * k) + '%'; c.style.top = '0';
        sc.appendChild(c);
      }
      sc.querySelectorAll(':scope > .scrolling-content__item[style*="absolute"]').forEach(function (c) { c.style.top = '0'; });
      var pxs = (parseFloat(mq.getAttribute('speed')) || 0.2) * 300;   /* px por segundo */
      var dir = mq.getAttribute('direction') === 'right' ? 1 : -1;
      var x = dir > 0 ? -iw : 0, paused = false, last = 0;
      if (mq.hasAttribute('pause-on-hover')) {
        mq.addEventListener('mouseenter', function () { paused = true; });
        mq.addEventListener('mouseleave', function () { paused = false; });
      }
      function tick(ts) {
        var dt = last ? Math.min(64, ts - last) : 16; last = ts;
        if (!paused) {
          x += dir * pxs * dt / 1000;
          if (dir < 0 && -x >= iw) x += iw;
          if (dir > 0 && x >= 0) x -= iw;
          sc.style.transform = 'translateX(' + x + 'px)';
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      mq.__clReset = function () { iw = sc.getBoundingClientRect().width || iw; };
    });
  }

  /* 5 */
  function accordions() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.closest(SEC)) return;
      d.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      Array.prototype.forEach.call(d.children, function (c) {
        if (c.tagName === 'SUMMARY') return;
        if (d.open) { c.style.height = ''; c.style.opacity = ''; c.style.overflow = ''; c.style.visibility = ''; }
      });
      if (d.open && d.closest('[data-cl-single], .accordion-list, .faq')) {
        var grp = d.parentElement && d.parentElement.closest('[data-cl-single]');
        if (grp) grp.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest(SEC + ' button[aria-controls]');
      if (!b || b.closest('cl-carousel-prev-button, cl-carousel-next-button, [data-cl-sort], [data-cl-filter]')) return;
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel || !panel.closest(SEC)) return;
      if (panel.tagName === 'DIALOG' || /drawer|popover|modal|quick-buy/i.test(panel.className + ' ' + panel.id)) return;
      e.preventDefault();
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height .3s ease';
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { panel.style.height = '0px'; });
        panel.setAttribute('aria-hidden', 'true');
      } else {
        panel.hidden = false; panel.style.visibility = 'visible'; panel.style.opacity = '1';
        panel.style.height = panel.scrollHeight + 'px';
        panel.setAttribute('aria-hidden', 'false');
        setTimeout(function () { if (b.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto'; }, 320);
      }
    });
  }

  /* 6 */
  function collectionUi() {
    document.addEventListener('click', function (e) {
      var s = e.target.closest('[data-cl-sort]');
      var pops = document.querySelectorAll('[data-cl-sort-pop]');
      if (s) { e.preventDefault(); var p = s.parentNode.querySelector('[data-cl-sort-pop]'); if (p) p.hidden = !p.hidden; return; }
      if (!e.target.closest('[data-cl-sort-pop]')) pops.forEach(function (p) { p.hidden = true; });
      var f = e.target.closest('[data-cl-filter]');
      if (f) { e.preventDefault(); document.documentElement.classList.toggle('cl-facets-open'); return; }
      if (document.documentElement.classList.contains('cl-facets-open') && e.target.closest('.cl-facets-close, .cl-facets-scrim')) document.documentElement.classList.remove('cl-facets-open');
    });
    document.addEventListener('change', function (e) {
      var form = e.target.closest('form[data-cl-facets]');
      if (form) form.submit();
    });
  }

  /* 7 */
  function autoVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll(SEC + ' video')).filter(function (v) { return !v.controls; });
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }


  /* 8. Swiper oficial (assets/cl-swiper.js) com a config do tema dele: "Customer Photos" da PDP.
     O extract grava o estado inicializado (classes, width/margin inline, transform) -> desfaz antes. */
  function swipers() {
    if (!window.Swiper) return false;
    /* About us dele: timeline "Our Journey" e "Shop by Categories" (config do script inline da secao dele) */
    [[' .bannerImg .slider-image-card', function (el) { return { slidesPerView: 1, spaceBetween: 16, watchOverflow: true,
        navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
        breakpoints: { 768: { slidesPerView: 3, spaceBetween: 24 } } }; }],
     [' .swiper.collection-section', function () { return { slidesPerView: 2, spaceBetween: 12, watchOverflow: true,
        breakpoints: { 768: { slidesPerView: 4, spaceBetween: 20 } } }; }]].forEach(function (c) {
      document.querySelectorAll(SEC + c[0]).forEach(function (el) {
        if (el.__clSw) return;
        el.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
        var w = el.querySelector('.swiper-wrapper'); if (w) { w.style.transform = ''; w.style.transitionDuration = ''; w.removeAttribute('id'); }
        el.querySelectorAll('.swiper-slide').forEach(function (s) { s.style.width = ''; s.style.marginRight = ''; s.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev'); });
        el.querySelectorAll('.swiper-button-disabled').forEach(function (b) { b.classList.remove('swiper-button-disabled'); });
        try { el.__clSw = new window.Swiper(el, c[1](el)); } catch (e) { console.warn('cl swiper', e); }
      });
    });
    document.querySelectorAll(SEC + ' .buyersShowSwiper').forEach(function (el) {
      if (el.__clSw) return;
      el.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
      var w = el.querySelector('.swiper-wrapper'); if (w) { w.style.transform = ''; w.style.transitionDuration = ''; w.removeAttribute('id'); }
      el.querySelectorAll('.swiper-slide').forEach(function (s) { s.style.width = ''; s.style.marginRight = ''; s.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev'); });
      var sc = el.closest(SEC) || el.parentElement;
      var pg = sc.querySelector('.swiper-pagination'); if (pg) pg.innerHTML = '';
      try {
        el.__clSw = new window.Swiper(el, {
          pagination: { el: pg, type: 'progressbar' },
          breakpoints: { 0: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 20 }, 1480: { slidesPerView: 5, spaceBetween: 20 } },
          navigation: { nextEl: sc.querySelector('.swiper-button-next'), prevEl: sc.querySelector('.swiper-button-prev') }
        });
      } catch (e) { console.warn('cl swiper', e); }
    });
    return true;
  }

  function boot() {
    slideshows(); slicks(); marquees(); autoVideos();
    if (!swipers()) { var sn = 0, st = setInterval(function () { if (swipers() || ++sn > 40) clearInterval(st); }, 150); }
    var n = 0, t = setInterval(function () { slicks(); marquees(); if (++n > 20) clearInterval(t); }, 500);
    window.addEventListener('resize', function () { slicks(); marquees(); document.querySelectorAll('cl-marquee-text').forEach(function (m) { m.__clReset && m.__clReset(); }); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cl-top]');
    if (a) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });
  /* botao/rotulo que leva a uma pagina (compra rapida do card, SHOP THE LOOK, +N cores) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cl-href]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    location.href = b.getAttribute('data-cl-href');
  });
  /* swatch do card: troca a foto principal pela da variante */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i.matches || !i.matches('cl-product-card input[data-cl-swimg]')) return;
    var src = i.getAttribute('data-cl-swimg'), card = i.closest('cl-product-card');
    var img = card && card.querySelector('[data-cl-primary]');
    if (src && img) { img.removeAttribute('srcset'); img.src = src; }
  });
  /* colecao: estilo (filtro nativo por tag), Filter mostra/esconde a fila, Read More do artigo, FAQ */
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('input[data-cl-style-url]');
    if (i) location.href = i.getAttribute('data-cl-style-url');
  });
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-cl-filter-toggle]');
    if (f) { e.preventDefault(); var s = f.closest(SEC); if (s) s.classList.toggle('cl-facets-hidden'); return; }
    var a = e.target.closest('[data-cl-article]');
    if (a) {
      e.preventDefault();
      var box = a.parentElement.querySelector('[data-collapsible-content]');
      var open = a.getAttribute('aria-expanded') !== 'true';
      a.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (box) { box.classList.toggle('is-expanded', open); box.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      a.textContent = open ? (a.getAttribute('data-expanded-text') || 'Show Less') : (a.getAttribute('data-collapsed-text') || 'Read More');
      return;
    }
    var q = e.target.closest(SEC + ' .default-faq-question');
    if (q) { var it = q.closest('.default-faq-item'); if (it) it.classList.toggle('is-open'); }
  });
  accordions(); collectionUi(); scrollCarousels();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
